import React from 'react'

const Wood = (props) => (
  <div id={props.Id} className="story">
    <h3>Choice of finish</h3>
    <p>
      With a large selection of finishes from our standard range, you can tailor the <strong>{props.ProductName}</strong> to match your style and needs. Below is a small sample of our colour range.
    </p>
    <ul className="samples">
      <li title="Whyte's white">
        <img src="/static/images/asfalt-light.png" alt="" style={{ backgroundColor: '#E4E1DA' }}/>
      </li>
      <li title="Lumi">
        <img src="/static/images/asfalt-light.png" alt="" style={{ backgroundColor: '#F0EEE8' }}/>
      </li>
      <li title="Poro">
        <img src="/static/images/asfalt-light.png" alt="" style={{ backgroundColor: '#D2C3B0' }}/>
      </li>
      <li title="Hamilton grey">
        <img src="/static/images/asfalt-light.png" alt="" style={{ backgroundColor: '#9B9188' }}/>
      </li>
      <li title="Mjolnir">
        <img src="/static/images/asfalt-light.png" alt="" style={{ backgroundColor: '#8A8681' }}/>
      </li>
      <li title="Raspberry fool">
        <img src="/static/images/asfalt-light.png" alt="" style={{ backgroundColor: '#B9557E' }}/>
      </li>
    </ul>
</div>
)

export default Wood